import React from 'react';
import '../styles/ServicesSidebar.css';

const ServicesSidebar = ({
  categories,
  selectedCategory,
  onCategorySelect,
  searchQuery,
  onSearchChange,
  totalCount,
  getCategoryCount,
  servicesCardData,
  onProfileSelect
}) => {
  // Get total count of all professionals
  const getAllProfessionalsCount = () => {
    let total = 0;
    Object.keys(servicesCardData || {}).forEach(category => {
      total += (servicesCardData[category] || []).length;
    });
    return total;
  };

  const totalProfessionals = getAllProfessionalsCount();

  // Filter categories based on search query
  const filteredCategories = categories.filter(category => {
    if (!searchQuery) return true;
    const searchLower = searchQuery.toLowerCase();
    return category.toLowerCase().includes(searchLower);
  });

  return (
    <aside className="services-sidebar">
      <div className="sidebar-header">
        <h2>All Services</h2>
        <p className="sidebar-subtitle">{totalProfessionals} Professionals</p>
      </div>
      
      <div className="sidebar-search">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="sidebar-search-icon">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <input
          type="text"
          placeholder="Search services..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="sidebar-search-input"
        />
        {searchQuery && (
          <button 
            className="sidebar-clear-search" 
            onClick={() => onSearchChange('')}
            title="Clear search"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
      </div>

      {/* All Service Categories Section */}
      <div className="sidebar-service-categories">
        <h3 className="service-categories-title">Service Categories</h3>
        <div className="service-categories-list">
          {/* All Services Button */}
          <button
            className={`sidebar-category-item ${selectedCategory === 'all-services' ? 'active' : ''}`}
            onClick={() => onCategorySelect('all-services')}
          >
            <span className="category-name">All Services</span>
            <span className="category-count">{totalProfessionals}</span>
          </button>
          
          {filteredCategories.length === 0 ? (
            <div className="sidebar-empty">
              <p>No services found</p>
            </div>
          ) : (
            filteredCategories.map((category) => {
              const categoryProfessionals = servicesCardData[category] || [];
              const categoryCount = categoryProfessionals.length;
              return (
                <button
                  key={category}
                  className={`sidebar-category-item ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => onCategorySelect(category)}
                >
                  <span className="category-name">{category}</span>
                  <span className="category-count">{categoryCount}</span>
                </button>
              );
            })
          )}
        </div>
      </div>
    </aside>
  );
};

export default ServicesSidebar;

